import {
  Box,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  TextField,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";

import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";

import Slide from "@mui/material/Slide";

import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";

import AddIcon from "@mui/icons-material/Add";

import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import StatusAlert from "../../StatusAlertList/StatusAlert";

import NoticeBoardHeader from "./NoticeBoardHeader";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";
import { noticeBoardApis } from "../../Data/axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function NoticeBoard() {
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [noticeHeading, setNoticeHeading] = useState("");
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [departments, setDepartments] = useState(null);
  const [selectedRadio, setSelectedRadio] = useState("Client");
  const [pageValue, setPageValue] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowCountValue, setRowCountValue] = useState(0);
  const navigate = useNavigate();
  const [radioButton, setRadioButton] = useState(false);
  const [noticeData, setNoticeData] = useState([]);
  const [update, setUpdate] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [userType, setUserType] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selection, setSelection] = useState(null);

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickUpdate = () => {
    setUpdate(true);
  };

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };

  const handleSearchButton = async () => {
    const result = await fetch(
      `https://rptpl.roadpilot.co.in/public/api/Noticefilter?text=${searchValue}`,
      {
        method: "POST",
      }
    );
    const response = await result.json();
    const updatedResponse = response.map((notice) => ({
      ...notice,
      notice_to: convertToUserType(notice.notice_to),
      user_type: convertToMainUserType(notice.user_type), // convert the value
    }));
    setNoticeData(updatedResponse);
  };
  useEffect(() => {
    handleSearchButton();
  }, [searchValue]);

  const handleDateButton = async () => {
    // const result = await fetch(
    //   `https://rptpl.roadpilot.co.in/public/api/Noticefilter?start_date=${startDate}&end_date=${endDate}`,
    //   {
    //     method: "POST",
    //   }
    // );
    // const response = await result.json();
    // const updatedResponse = response.map((notice) => ({
    //   ...notice,
    //   notice_to: convertToUserType(notice.notice_to),
    //   user_type: convertToMainUserType(notice.user_type), // convert the value
    // }));
    // setNoticeData(updatedResponse);
  };
  // useEffect(() => {
  //   handleDateButton();
  // }, [startDate, endDate]);
  const handleCancel = () => {
    navigate("/notice");
  };
  const handleViewMore = async () => {
    try {
      let rowData = await noticeBoardApis.editById(openMenuId);
      console.log(rowData, "rowData");
      navigate(`/notice/${openMenuId}`, { state: rowData });
    } catch (error) {
      console.error(error, "error");
    }
  };

  // Function Starts Here

  const userData = localStorage.getItem("user-info");
  let creator;
  if (userData) {
    // Parse the JSON string into an object
    const parsedData = JSON.parse(userData);

    // Access the name property from the parsed object
    creator = parsedData.value.name;
  } else {
    console.error("No user data found in localStorage.");
  }
  let valueToSend;

  if (selectedRadio === "Client") {
    valueToSend = 1;
  } else if (selectedRadio === "Employee") {
    valueToSend = 2;
  } else if (selectedRadio === "App User") {
    valueToSend = 3;
  }

  const item = {
    title: noticeHeading,
    description: description,
    notice_to: valueToSend,
    user_type: userType,
    department: departments,
  };

  async function SaveData() {
    try {
      const formData = new FormData();
      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }

      await noticeBoardApis.add(formData);

      showAlert("Added successfully", "success");
      // handleAllData();
      getData();
      setOpen(false);
    } catch (error) {
      console.error(error);
      showAlert("Failed to add", "warning");
    }
  }

  useEffect(() => {
    getData();
  }, [rowsPerPage, pageValue, searchValue]);

  async function getData() {
    const response = await noticeBoardApis.getAll(
      pageValue,
      rowsPerPage,
      selection?.props?.value,
      searchValue
    );
    const updatedResponse = response.data.map((notice) => ({
      ...notice,
      notice_to: convertToUserType(notice.notice_to),
      user_type: convertToMainUserType(notice.user_type), // convert the value
    }));
    setTotalPages(response?.total_pages);
    setRowCountValue(response?.total_records);
    setRowsPerPage(response?.limit);
    setNoticeData(updatedResponse);
  }
  const convertToUserType = (value) => {
    if (value === "1") return "Client";
    if (value === "2") return "Employee";
    if (value === "3") return "App User";
    return "Unknown"; // Fallback for invalid values
  };
  const convertToMainUserType = (value) => {
    if (value === "1") return "Driver";
    if (value === "2") return "Owner";
    if (value === "3") return "Dhaba";
    if (value === "4") return "Mechanic";
    if (value === "5") return "Crane Owner";
    if (value === "6") return "Crane Operator";

    return "Unknown"; // Fallback for invalid values
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };
  const columns = [
    {
      name: "title",
      label: "Notice",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Notice
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "created_at",
      label: "Date",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Date
            </th>
          );
        },
        customBodyRender: (value) => {
          const date = new Date(value);

          // Extract the day, month, and year from the Date object
          const day = String(date.getDate()).padStart(2, "0"); // Adds leading zero if necessary
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
          const year = date.getFullYear();

          // Format the date as "DD-MM-YYYY"
          const formattedDate = `${day}-${month}-${year}`;
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {formattedDate}
            </div>
          );
        },
      },
    },
    {
      name: "notice_to",
      label: "To",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              To
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },

    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "20px", // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "20px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {userPermissions?.notice_add !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleViewMore(tableMeta.rowData)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <RemoveRedEyeIcon /> View More
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.notice_update !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleEdit(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <EditNoteIcon /> Edit
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.notice_delete !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleDelete(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <DeleteForeverIcon /> Delete
                      </div>
                    </MenuItem>
                  )}
                </Menu>
              </div>
            </div>
          </>
        ),
      },
    },
  ];

  async function handleEdit(id) {
    let resultNew = await noticeBoardApis.editById(openMenuId);

    navigate(`/notice/${openMenuId}/edit`, { state: resultNew });

    handleClickUpdate();
  }

  const handleUpdateClose = () => {
    setOpen(false);
  };

  async function handleDelete() {
    await noticeBoardApis.deleteById(openMenuId);
    getData();
    showAlert(" Deleted successfully", "warning");
  }

  // end delete

  const rowsPerPageOptions = [5, 10, 25, 100];

  const options = {
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPageValue(0);
    },
    totalPages: totalPages, // Adding total pages
    onChangePage: (currentPage) => {
      setPageValue(currentPage + 1);
    },
    customFooter: (
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <span>
              Showing {page * rowsPerPage + 1} -{" "}
              {Math.min(rowCountValue, (page + 1) * rowsPerPage)} of{" "}
              {rowCountValue} entries
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <label htmlFor="rowsPerPage">Rows per page: </label>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => changeRowsPerPage(Number(e.target.value))}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ padding: "10px", textAlign: "right" }}>
              Page {page + 1} of {totalPages}
              <Button
                variant="outlined"
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Previous
              </Button>
              <Button
                variant="outlined"
                onClick={() => changePage(page + 1)}
                disabled={page + 1 === totalPages}
                sx={{
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      );
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {},
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });
  useEffect(() => {
    if (selectedRadio === "App User") {
      setRadioButton(true);
    } else {
      setRadioButton(false);
    }
  }, [selectedRadio]);

  const handleAddButton = () => {
    navigate("/notice/create");
  };
  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      <NoticeBoardHeader
        selection={selection}
        setSelection={setSelection}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      <List
        style={{
          background: "none",
          padding: 5,
          marginTop: "10px",
        }}
      >
        <React.Fragment>
          {userPermissions?.notice_add !== 0 && (
            <Stack direction="row" spacing={2} sx={{ marginBottom: "5px" }}>
              <Box
                onClick={handleClickOpen}
                sx={{
                  backgroundColor: "#1d82f5",
                  "&:hover": { backgroundColor: "orange" },
                  textAlign: "center",
                  padding: "10px",
                  marginLeft: "10px",
                  height: "40px",
                  width: "115px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderRadius: "4px",
                  fontSize: "15px",
                  fontFamily: "sans-serif",
                  cursor: "pointer",
                }}
              >
                <AddIcon />
                Add Notice
              </Box>
            </Stack>
          )}
          <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              style: {
                position: "absolute",
                background: "#141b2d",
                top: "0",
                backgroundColor: "white",
                maxHeight: "95%",
                margin: "auto",
                overflowX: "hidden",
                zIndex: 1200,
              },
            }}
          >
            <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <Close fontSize="large" />
                </IconButton>
                <Typography
                  sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                  component="div"
                >
                  Add New Notice
                </Typography>
              </Toolbar>
            </AppBar>
            <Box sx={{ background: "#fff" }}>
              <Grid
                container
                spacing={2}
                sx={{
                  padding: { xs: "20px", sm: "20px" },
                  color: "#000",
                }}
              >
                <Grid item xs={11} sm={6} md={6}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={selectedRadio}
                      onChange={(e) => setSelectedRadio(e.target.value)}
                    >
                      <FormControlLabel
                        value="Client"
                        control={
                          <Radio
                            sx={{
                              color: "black",
                              "&.Mui-checked": { color: "#1d82f5" },
                            }}
                          />
                        }
                        label="Client"
                      />
                      <FormControlLabel
                        value="Employee"
                        control={
                          <Radio
                            sx={{
                              color: "black",
                              "&.Mui-checked": { color: "#1d82f5" },
                            }}
                          />
                        }
                        label="Employee"
                      />
                      <FormControlLabel
                        value="App User"
                        control={
                          <Radio
                            sx={{
                              color: "black",
                              "&.Mui-checked": { color: "#1d82f5" },
                            }}
                          />
                        }
                        label="App User"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {radioButton && (
                  <Grid item xs={11} sm={5} md={5}>
                    <Typography sx={{ color: "#000", paddingBottom: "7px" }}>
                      UserType
                    </Typography>
                    <Select
                      value={userType}
                      autoFocus
                      fullWidth
                      onChange={(e) => setUserType(e.target.value)}
                      displayEmpty
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={1}>Driver</MenuItem>
                      <MenuItem value={2}>Owner</MenuItem>
                      <MenuItem value={3}>Dhaba</MenuItem>
                      <MenuItem value={4}>Mechanic</MenuItem>
                      <MenuItem value={5}>Crane Owner</MenuItem>
                      <MenuItem value={6}>Crane Operator</MenuItem>
                    </Select>
                  </Grid>
                )}
              </Grid>

              <Grid
                container
                spacing={2}
                sx={{
                  padding: { xs: "20px", sm: "20px" },
                }}
              >
                <Grid item xs={12} sm={5.5} md={5.5}>
                  <Stack direction="column" spacing={2}>
                    <Typography sx={{ color: "#000" }}>
                      Notice Heading
                    </Typography>
                    <TextField
                      autoFocus
                      margin="dense"
                      placeholder="Notice Heading Name"
                      type="text"
                      fullWidth
                      value={noticeHeading}
                      onChange={(e) => setNoticeHeading(e.target.value)}
                      inputProps={{ style: { color: "black" } }}
                      InputLabelProps={{
                        style: { color: "black" },
                      }}
                      sx={{
                        border: "1px solid black",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={5.5} md={5.5}>
                  <Stack direction="column" spacing={2}>
                    <Typography sx={{ color: "#000" }}>Department</Typography>
                    <Select
                      value={departments}
                      autoFocus
                      fullWidth
                      onChange={(e) => setDepartments(e.target.value)}
                      displayEmpty
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={"Trainee"}>Trainee</MenuItem>
                      <MenuItem value={"Junior"}>Junior</MenuItem>
                      <MenuItem value={"Senior"}>Senior</MenuItem>
                      <MenuItem value={"TeamLead"}>Team Lead</MenuItem>
                      <MenuItem value={"ProjectManager"}>
                        Project Manager
                      </MenuItem>
                    </Select>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container sx={{ padding: "20px" }}>
                <Stack direction="column" sx={{ width: "100%" }}>
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Notice Details<span style={{ color: "red" }}>*</span>
                  </Typography>

                  <ReactQuill
                    value={description}
                    onChange={setDescription}
                    modules={modules}
                    theme="snow"
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      color: "black",
                      borderBlockColor: "black",
                    }}
                  />
                </Stack>
              </Grid>

              <Grid
                container
                sx={{
                  padding: {
                    xs: "80px 10px 20px 10px",
                    sm: "60px 10px 20px 10px",
                    md: "50px 10px 20px 10px",
                  },
                }}
              >
                <Grid item xs={11} className="messageFooter">
                  <Box className="response" onClick={SaveData}>
                    Save
                  </Box>
                  <Box className="cancel" onClick={handleCancel}>
                    Cancel
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Dialog>
        </React.Fragment>

        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <Box
              sx={{
                maxWidth: "100%",
              }}
            >
              <MUIDataTable
                title={
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "1.5rem",
                      color: "#333",
                    }}
                  >
                    Notice Lists
                  </span>
                }
                data={noticeData}
                columns={columns}
                options={options}
              />
            </Box>
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default NoticeBoard;
